import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { Draggable, Droppable } from "@hello-pangea/dnd";
import QuickListItem from "components/Homeowner/Dashboard/QuickListItem";

const grid = 8;

const Title = styled.div`
  flex-grow: 1;
  user-select: none;
  position: relative;
  overflow: hidden;
  &:focus {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
  }
`;

const Wrapper = styled.div`
  background-color: var(--dnd-bg-color);
  display: flex;
  flex-direction: column;
  opacity: ${({ $isDropDisabled }) => ($isDropDisabled ? 0.5 : "inherit")};
  padding: ${grid}px;
  border: ${grid}px;
  padding-bottom: 0;
  transition: background-color 0.2s ease, opacity 0.1s ease;
  user-select: none;
  width: 192px;
`;

const scrollContainerHeight = 250;

const DropZone = styled.div`
  /* stop the list collapsing when empty */
  min-height: ${scrollContainerHeight}px;

  /*
    not relying on the items for a margin-bottom
    as it will collapse when the list is empty
  */
  padding-bottom: ${grid}px;
`;

const InnerQuickListGroupList = React.memo(function InnerQuickListGroupList(props) {
  return props.quotes.map((quote, index) => (
    <Draggable key={quote.id} draggableId={String(quote.id)} index={index}>
      {(
        dragProvided,
        dragSnapshot,
      ) => (
          <QuickListItem
            key={quote.id}
            item={quote}
            isDragging={dragSnapshot.isDragging}
            isGroupedOver={Boolean(dragSnapshot.combineTargetFor)}
            provided={dragProvided}
            snapshot={dragSnapshot}
          />
        )}
    </Draggable>

  ));
});

InnerQuickListGroupList.propTypes = {
  listId: PropTypes.string,
  listType: PropTypes.string,
  quotes: PropTypes.array,
  title: PropTypes.string,
  internalScroll: PropTypes.bool,
  scrollContainerStyle: PropTypes.object,
  isDropDisabled: PropTypes.bool,
  isCombineEnabled: PropTypes.bool,
  style: PropTypes.object,
  ignoreContainerClipping: PropTypes.bool,
};


function InnerList(props) {
  const { quotes, dropProvided } = props;
  const title = props.title ? <Title>{props.title}</Title> : null;

  return (
    <div>
      {title}
      <DropZone ref={dropProvided.innerRef}>
        <InnerQuickListGroupList quotes={quotes} />
        {dropProvided.placeholder}
      </DropZone>
    </div>
  );
}
InnerList.propTypes = {
  dropProvided: PropTypes.object,
  quotes: PropTypes.array,
  title: PropTypes.string
};

export default function QuickListGroupList(props) {
  const {
    ignoreContainerClipping,
    isDropDisabled,
    isCombineEnabled,
    listId = "LIST",
    listType,
    style,
    quotes,
    title,
  } = props;

  const getDroppableContent = (dropProvided, dropSnapshot) => (
      <Wrapper
        style={style}
        $isDraggingOver={dropSnapshot.isDraggingOver}
        $isDropDisabled={isDropDisabled}
        $isDraggingFrom={Boolean(dropSnapshot.draggingFromThisWith)}
        {...dropProvided.droppableProps}
      >
        <InnerList
          quotes={quotes}
          title={title}
          dropProvided={dropProvided}
        />
      </Wrapper>
    );

  return (
    <Droppable
      droppableId={listId}
      type={listType}
      ignoreContainerClipping={ignoreContainerClipping}
      isDropDisabled={isDropDisabled}
      isCombineEnabled={isCombineEnabled}
      children={getDroppableContent}
    />
  );
}
QuickListGroupList.propTypes = {
  ignoreContainerClipping: PropTypes.bool,
  internalScroll: PropTypes.bool,
  scrollContainerStyle: PropTypes.object,
  isDropDisabled: PropTypes.bool,
  isCombineEnabled: PropTypes.bool,
  listId: PropTypes.string,
  listType: PropTypes.string,
  style: PropTypes.object,
  quotes: PropTypes.array,
  title: PropTypes.string,
};
